import { Button, Divider, Form, Input, Modal, Select, Upload, DatePicker } from "antd";
import { useState, useRef, useEffect } from "react";
import * as Validation from "../../../../utils/helper/validation";
import * as Apis from "../../../../utils/helper/enum";
import { changeLoader } from "../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";

import config from "../../../../config";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import {
  GoogleMap,
  LoadScript,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";
import { IoLocationOutline } from "react-icons/io5";

const mapContainerStyle = {
  height: "400px",
  width: "100%",
};

const libraries = ["places"];

const center = {
  lat: config.lat,
  lng: config.lng,
};
const vendor_Type = [
  {
    value: "canned_seller",
    label: "Canned Seller",
  },
];
const SellerPersonalDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  const cropperRef = useRef(null);
  const [image, setImage] = useState(null);

  const [previewImage, setPreviewImage] = useState("");
  const [avatarPreview, setAvatarPreview] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [croppingType, setCroppingType] = useState("business"); // "business" or "avatar"

  const [allCategories,setAllCategories] = useState([]); //allCategories
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [avatarFileList, setAvatarFileList] = useState([]);

  const [markerPosition, setMarkerPosition] = useState(center);
  const [address, setAddress] = useState("");
  const [autocomplete, setAutocomplete] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);
  const geocoder = useRef(null);

  let { id } = useParams();

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  const handleUpload = ({ file }, type = "business") => {
    const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > maxSize) {
      toast.error("File size must be less than 5 MB.");
      return false;
    }

    if (file.status === "removed") return false;

    setCroppingType(type);
    const reader = new FileReader();
    reader.onload = () => setImage(reader.result);
    reader.readAsDataURL(file);
    setPreviewOpen(true);
    return false;
  };

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const canvas = cropper.getCroppedCanvas({
        width: 500,
        height: 500,
      });
      const croppedImage = canvas.toDataURL("image/jpeg", 0.7);
      if (croppingType === "business") {
        setFileList([
          {
            uid: "-1",
            name: "image.png",
            status: "done",
            url: croppedImage,
          },
        ]);
        setPreviewImage(croppedImage);
      } else {
        setAvatarFileList([
          {
            uid: "-1",
            name: "avatar.png",
            status: "done",
            url: croppedImage,
          },
        ]);
        setAvatarPreview(croppedImage);
      }
      setPreviewOpen(false);
    }
  };

  const handleRemove = (file, type = "business") => {
    if (type === "business") {
      setFileList([]);
      setPreviewImage("");
    } else {
      setAvatarFileList([]);
      setAvatarPreview("");
    }
    setPreviewOpen(false);
  };

  const uploadButton = (type = "business") => (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <img
        src={
          type === "business"
            ? previewImage
              ? previewImage
              : config.IMAGEBASEURL + `images/upload-img.png`
            : avatarPreview
            ? avatarPreview
            : config.IMAGEBASEURL + `images/upload-img.png`
        }
        alt="Upload"
      />
    </button>
  );

  const onLoadAutocomplete = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const location = place.geometry.location;
      setAddress(place.formatted_address);
      setMarkerPosition({
        lat: location.lat(),
        lng: location.lng(),
      });
      setInputValue(place.formatted_address);
      form.setFieldValue("location", place.formatted_address);
    }
  };

  const onMarkerDragEnd = (e) => {
    let newLat = e.latLng.lat();
    let newLng = e.latLng.lng();
    setMarkerPosition({
      lat: newLat,
      lng: newLng,
    });
    geocodeLatLng(newLat, newLng);
    handleInputChange("location");
  };

  const geocodeLatLng = (lat, lng) => {
    if (!geocoder.current) {
      geocoder.current = new window.google.maps.Geocoder();
    }

    const latLng = { lat, lng };
    geocoder.current.geocode({ location: latLng }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          setAddress(results[0].formatted_address);
          setInputValue(results[0].formatted_address);
          form.setFieldValue("location", results[0].formatted_address);
        }
      }
    });
  };

    const getAllBusinessCategories = async () => {
      try {
        let response = await globalRequest(
          Apis.MANAGE_VENDOR.GET_ALL_BUSINESS_CATEGORIES,
          "get",
          {},
          {},
          true
        );
        let apiResponse = response?.data;
        if (response?.status === 200) {
          let data = apiResponse?.data?.map((item) => {
            return {
              value: item?.id,
              label: item?.locales?.[0]?.name || "No Name",
            };
          });
          setAllCategories(data);
          return data;
        } else {
          toast.error(apiResponse?.message);
          return []; 
        }
      } catch (e) {
        toast.error(e?.message);
        return [];
      }
    };

  const handleSubmit = async (values) => {
    if (previewImage === "") {
      form.setFields([
        {
          name: "business_image",
          errors: ["Please select your Profile picture."],
        },
      ]);
      return false;
    }

    if (values.total_no_of_branches === 0) {
      form.setFields([
        {
          name: "total_no_of_branches",
          errors: ["Enter the Total number of branches."],
        },
      ]);
      return false;
    }

    values.businessImage = previewImage;
    values.avatar = avatarPreview;
    values.vendor_type = "canned_seller";
    
    // Map internal form field names to model names if necessary
    values.businessName = values.business_name;
    values.storeName = values.store_name;
    values.commercialRegistrationNumber = values.registration_number;
    values.noOfBranches = values.total_no_of_branches;
    values.businessCategoryId = values.business_category_id;
    values.category = values.business_category_id; // Backend might expect 'category'
    
    // Map data
    values.lat = markerPosition.lat;
    values.lng = markerPosition.lng;
    values.location = address;
    values.address = address;
    
    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_CANNED_SELLER?.CREATE_CANNED_SELLER;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_CANNED_SELLER?.EDIT_CANNED_SELLER + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Canned Seller created successfully";
        if (id) msg = "Canned Seller updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-seller");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getVendorDetail = async (id) => {
    try {
      let response = await globalRequest(Apis.MANAGE_CANNED_SELLER.GET_CANNED_SELLER_DETAIL + "/" + id, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        if (Array.isArray(data)) {
          data = data[0];
        }

        // Handle both flattened and nested (under vendorDetail) structures
        const sellerData = data?.vendorDetail || data;
        const userData = data?.user || data;

        form.setFieldValue("business_name", sellerData?.businessName);
        form.setFieldValue("store_name", sellerData?.storeName);
        form.setFieldValue("first_name", userData?.firstName);
        form.setFieldValue("last_name", userData?.lastName);
        form.setFieldValue("email", userData?.email);

        form.setFieldValue("address", sellerData?.location || sellerData?.address);
        form.setFieldValue("business_category_id", sellerData?.category || sellerData?.businessCategoryId);
        form.setFieldValue("registration_number", sellerData?.commercialRegistrationNumber);
        form.setFieldValue("total_no_of_branches", sellerData?.noOfBranches);

        let mobileStr = userData?.mobileNo || "";
        let mobile = mobileStr.split("-");
        form.setFieldValue("mobile_no", mobile[mobile.length - 1]);
        form.setFieldValue("vat", sellerData?.vat);
        
        // New model fields
        form.setFieldValue("productsCount", sellerData?.productsCount);
        form.setFieldValue("machinesCount", sellerData?.machinesCount);
        form.setFieldValue("category", sellerData?.category);
        form.setFieldValue("location", sellerData?.location);

        if (sellerData?.lat && sellerData?.lng) {
          setMarkerPosition({
            lat: Number(sellerData?.lat),
            lng: Number(sellerData?.lng),
          });
        }
        setAddress(sellerData?.location || sellerData?.address);
        setInputValue(sellerData?.location || sellerData?.address);

        if (sellerData?.businessImage) {
          setPreviewImage(`https://rabbitholebucket.s3.eu-north-1.amazonaws.com/` + sellerData?.businessImage);
        }
        if (sellerData?.avatar) {
          setAvatarPreview(`https://rabbitholebucket.s3.eu-north-1.amazonaws.com/` + sellerData?.avatar);
        }
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      dispatch(changeLoader(true));
      
      await getAllBusinessCategories();
      if (id) {
        await getVendorDetail(id);
      } else {
        form.setFieldValue("total_no_of_branches", 1);
      }
      setIsDataLoaded(true);
      dispatch(changeLoader(false));
    };

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <div className="min-h-[calc(100vh_-_305px)]">
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          style={{
            maxWidth: 600,
            width: "100%",
          }}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
        >
          <Form.Item
            label="Business Name"
            name="business_name"
            rules={[
              {
                required: true,
                message: "Please enter your Business Name.",
              },
              {
                max: 100,
                message: "Maximum 100 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("business_name", value.trimStart());
                handleInputChange("business_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Store Name"
            name="store_name"
            rules={[
              {
                required: true,
                message: "Please enter your Store Name.",
              },
              {
                max: 100,
                message: "Maximum 100 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("store_name", value.trimStart());
                handleInputChange("store_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Canned Seller First Name"
            name="first_name"
            rules={[
              {
                required: true,
                message: "Please enter your Canned Seller First Name.",
              },
              {
                max: 50,
                message: "Maximum 50 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("first_name", value.trimStart());
                handleInputChange("first_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Canned Seller Last Name"
            name="last_name"
            rules={[
              {
                required: true,
                message: "Please enter your Canned Seller Last Name.",
              },
              {
                max: 50,
                message: "Maximum 50 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("last_name", value.trimStart());
                handleInputChange("last_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Email Address"
            name="email"
            rules={[
              {
                required: true,
                message: "Please enter your Email Address.",
              },
              {
                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Please enter a valid email address.",
              },
              {
                max: 100,
                message: "Maximum 100 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              disabled={id ? true : false}
              size="large"
              onChange={(e) => {
                form.setFieldValue("email", e.target.value.trimStart());
                handleInputChange("email");
              }}
            />
          </Form.Item>

          <Form.Item
            label="Mobile no"
            name="mobile_no"
            rules={[
              {
                required: true,
                message: "Please enter your Canned Seller mobile number.",
              },
              {
                min: 9,
                message: "Mobile number must be 9 digits",
              },
              {
                max: 9,
                message: "Mobile number must be no more than 9 digits",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              addonBefore={<span>+966</span>}
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "number");
                form.setFieldValue("mobile_no", value.trimStart());
                handleInputChange("mobile_no");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Business image"
            name="business_image"
            rules={[
              {
                required: id ? false : true,
                message: "Please Select your Business image.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <div className="mb-4 h-[102px]">
              <Upload
                listType="picture-card"
                fileList={fileList}
                beforeUpload={() => false}
                onChange={(info) => handleUpload(info, "business")}
                onRemove={(file) => handleRemove(file, "business")}
                showUploadList={{ showPreviewIcon: false }}
              >
                {fileList.length >= 1 ? null : uploadButton("business")}
              </Upload>
            </div>
          </Form.Item>
          
          <Form.Item
            label="Profile Avatar"
            name="avatar"
            rules={[
              {
                required: id ? false : true,
                message: "Please Select your Profile avatar.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <div className="mb-4 h-[102px]">
              <Upload
                listType="picture-card"
                fileList={avatarFileList}
                beforeUpload={() => false}
                onChange={(info) => handleUpload(info, "avatar")}
                onRemove={(file) => handleRemove(file, "avatar")}
                showUploadList={{ showPreviewIcon: false }}
              >
                {avatarFileList.length >= 1 ? null : uploadButton("avatar")}
              </Upload>
            </div>
          </Form.Item>
          <Form.Item
            label="Business Category"
            name="business_category_id"
            rules={[
              {
                required: true,
                message: "Please select seller Business Category.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Select
              size="large"
              placeholder="Select Business Category"
              options={allCategories}
              showSearch
              allowClear
              loading={!isDataLoaded}
              disabled={!isDataLoaded}
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                form.setFieldValue("business_category_id", value);
                handleInputChange("business_category_id");
              }}
            />
          </Form.Item>

          <Form.Item
            label="Commercial Registration number"
            name="registration_number"
            rules={[
              {
                required: true,
                message: "Please enter your Commercial Registration number.",
              },
              {
                max: 100,
                message: "Maximum 100 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "number");
                form.setFieldValue("registration_number", value.trimStart());
                handleInputChange("registration_number");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Total number of branches"
            name="total_no_of_branches"
            rules={[
              {
                required: true,
                type: "number",
                message: "Please enter your Total number of branches.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "number|max:3")
                  ? Number(Validation.strFormat(e.target.value, "number|max:3"))
                  : "";
                form.setFieldValue("total_no_of_branches", value);
                handleInputChange("total_no_of_branches");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Vat Number"
            name="vat"
            rules={[
              {
                required: true,
                message: "Please enter your vat number.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Number(Validation.strFormat(e.target.value, "number|max:16"))
                  ? Number(Validation.strFormat(e.target.value, "number|max:16"))
                  : "";
                form.setFieldValue("vat", value);
                handleInputChange("vat");
              }}
            />
          </Form.Item>

          <Form.Item
            label="Products Count"
            name="productsCount"
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "number")
                  ? Number(Validation.strFormat(e.target.value, "number"))
                  : "";
                form.setFieldValue("productsCount", value);
                handleInputChange("productsCount");
              }}
            />
          </Form.Item>

          <Form.Item
            label="Machines Count"
            name="machinesCount"
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "number")
                  ? Number(Validation.strFormat(e.target.value, "number"))
                  : "";
                form.setFieldValue("machinesCount", value);
                handleInputChange("machinesCount");
              }}
            />
          </Form.Item>

          <Form.Item
            label="Category"
            name="category"
          >
            <Input
              size="large"
              onChange={(e) => {
                form.setFieldValue("category", e.target.value.trimStart());
                handleInputChange("category");
              }}
            />
          </Form.Item>

          <Form.Item
            label="Location"
            name="location"
            rules={[
              {
                required: true,
                message: "Please enter your Location.",
              },
            ]}
          >
            <div className="responsive-map-container mt-4">
              <LoadScript
                googleMapsApiKey={config.GOOGLEMAPAPIKEY}
                libraries={libraries}
              >
                <Autocomplete
                  onLoad={onLoadAutocomplete}
                  onPlaceChanged={onPlaceChanged}
                >
                  <div
                    style={{
                      width: "60%",
                      position: "absolute",
                      zIndex: "1",
                      top: "20px",
                      left: "0",
                      right: "0",
                      margin: "auto",
                      padding: "10px",
                    }}
                  >
                    <Input
                      placeholder="Enter a location"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      ref={inputRef}
                    />
                  </div>
                </Autocomplete>

                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={markerPosition}
                  zoom={12}
                >
                  <Marker
                    position={markerPosition}
                    draggable={true}
                    onDragEnd={onMarkerDragEnd}
                  />
                </GoogleMap>
              </LoadScript>
              <div style={{ marginTop: "20px" }}>
                <h3 style={{ fontWeight: "bold", marginBottom: "12px" }}>
                  Street Address
                </h3>
                <p style={{ display: "flex", alignItems: "center" }}>
                  <IoLocationOutline style={{ marginRight: "10px" }} />
                  {address}
                </p>
              </div>
            </div>
          </Form.Item>
        </Form>
        <Divider />
        <div className="flex justify-end gap-3">
          <Button onClick={() => navigate("/manage-seller")}>Cancel</Button>
          <Button type="primary" htmlType="submit" onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      </div>
      <Modal
        open={previewOpen}
        onCancel={() => setPreviewOpen(false)}
        footer={[
          <Button key="back" onClick={() => setPreviewOpen(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleCrop}>
            Crop and Upload
          </Button>,
        ]}
      >
        <Cropper src={image} style={{ height: 400, width: "100%" }} aspectRatio={1} guides={false} ref={cropperRef} />
      </Modal>
    </>
  );
};
export default SellerPersonalDetails;
